/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type CallDealerModal_seller$ref = any;
export type CallDealerModal_seller = {
    readonly serviceId: string | null;
    readonly shippingAddress: {
        readonly displayCityStateCountry: string | null;
    } | null;
    readonly " $refType": CallDealerModal_seller$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CallDealerModal_seller",
    "type": "Seller",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "shippingAddress",
            "storageKey": null,
            "args": null,
            "concreteType": "Address",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "displayCityStateCountry",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'b7f63f5401a7c6cb76d0fef7aa2e4324';
export default node;
